const ALL_LEVELS = [
  { id: 1, name: "Beginner" },
  { id: 2, name: "Intermediate" },
  { id: 3, name: "Advanced" },
];
export { ALL_LEVELS };
